import { Tabs, TabsContent, TabsList, TabsTrigger } from "@loot-os/ui/components/tabs";
import { useParams, useRouter, useSearch } from "@tanstack/react-router";

import { ShopifyOrdersCard } from "../components/ShopifyOrdersCard";
import { ShopifyPurchasesCard } from "../components/ShopifyPurchasesCard";
import { ShopifyStoreCreditCard } from "../components/ShopifyStoreCreditCard";
import {
  isShopifySalesTab,
  resolveShopifySalesTab,
  SHOPIFY_SALES_TAB_LABELS,
  SHOPIFY_SALES_TABS,
  type ShopifySalesSearch,
} from "../lib/shopifySalesTabs";

/**
 * Shopify → Sales, a tab each: the box units bought at checkout, the $0 orders their claims ship
 * as, and the store credit waiting on Shopify. The tab rides `?tab=` (`shopifySalesTabs.ts`), so
 * a tab is a link.
 */
export function ShopifySalesPage() {
  const router = useRouter();
  const { tenantId } = useParams({ strict: false }) as { tenantId: string };
  const search = useSearch({ strict: false }) as ShopifySalesSearch;
  const activeTab = resolveShopifySalesTab(search.tab);

  return (
    <Tabs
      value={activeTab}
      onValueChange={(value) => {
        if (!isShopifySalesTab(value)) return;
        void router.navigate({
          to: "/tenants/$tenantId/shopify/sales",
          params: { tenantId },
          search: { tab: value },
          replace: true,
        });
      }}
      className="min-w-0 gap-4"
    >
      <TabsList>
        {SHOPIFY_SALES_TABS.map((tab) => (
          <TabsTrigger key={tab} value={tab}>
            {SHOPIFY_SALES_TAB_LABELS[tab]}
          </TabsTrigger>
        ))}
      </TabsList>
      <TabsContent value="purchases">
        <ShopifyPurchasesCard />
      </TabsContent>
      <TabsContent value="orders">
        <ShopifyOrdersCard />
      </TabsContent>
      <TabsContent value="store-credit">
        <ShopifyStoreCreditCard />
      </TabsContent>
    </Tabs>
  );
}
